// Cities featured in the footer's "Popular cities" block, linking to the
// /events/:citySlug landing pages. Ordered by gym coverage in our data so the
// links always land on pages with real content. Slugs must match
// utils/slugify.js output for the city name.
export const POPULAR_CITIES = [
  { name: 'London', slug: 'london' },
  { name: 'Madrid', slug: 'madrid' },
  { name: 'Barcelona', slug: 'barcelona' },
  { name: 'Hamburg', slug: 'hamburg' },
  { name: 'Dublin', slug: 'dublin' },
  { name: 'Athens', slug: 'athens' },
  { name: 'Berlin', slug: 'berlin' },
  { name: 'Stockholm', slug: 'stockholm' },
  { name: 'Amsterdam', slug: 'amsterdam' },
  { name: 'Manchester', slug: 'manchester' },
  { name: 'Paris', slug: 'paris' },
  { name: 'Munich', slug: 'munich' },
];
